import React from "react";
import dictionary from "../dictionary.js";

class CouncillorsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFullList: false
    };
  }
  render() {
    return (
      <div>
        <div
          onClick={() => {
            this.setState(prevState => {
              return { showFullList: !prevState.showFullList };
            });
          }}
          className="ui very fitted vertical segment center aligned text-action"
          style={{ cursor: "pointer" }}
        >
          <div>Afficher la liste détaillée des députés</div>
          <i
            className={
              "chevron icon " + (this.state.showFullList ? "up" : "down")
            }
          />
        </div>
        {this.state.showFullList && (
          <div className="ui segment">
            <div className="ui celled list">
              <table className="ui striped table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Canton</th>
                    <th>Parti</th>
                    <th>
                      {this.props.type === "mean" ? "Similarité" : "Vote"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.councillors.map((c, i) => (
                    <tr className="item" key={"councillor-" + i}>
                      <td>{c["CouncillorName"]}</td>
                      <td>{c["Canton"]}</td>
                      <td>
                        {
                          dictionary.parliamentaryGroups[
                            c["Groupe parlementaire"]
                          ]
                        }
                      </td>
                      <td>
                        {this.props.type === "mean"
                          ? Math.round(c["score"] * 1000) / 10 + "%"
                          : dictionary.answers[c["Vote"]]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CouncillorsList;
